import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa159246&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./index.vue?vue&type=style&index=0&id=fa159246&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fa159246",
  "1c8ab478"
  
)

export default component.exports